import { inject, Pipe, PipeTransform } from '@angular/core';
import { TranslationService } from './translation.service';

/**
 * Renders a translation key in templates.
 * Impure so templates update when the active locale changes.
 */
@Pipe({
  name: 'translate',
  pure: false,
})
export class TranslatePipe implements PipeTransform {
  private readonly translation = inject(TranslationService);

  transform(key: string, params?: Record<string, string>): string {
    this.translation.revision();
    return this.translation.translate(key, params);
  }
}
